import type { IExperience, IMultiExperience } from '~~/lib/ContentfulService';

export default function getFirstMatchingExperience(
  item: IMultiExperience
): IExperience | undefined {
  const { $matchingAudiences } = useNuxtApp();

  for (const experience of item.fields.experiences) {
    for (const id of experience.fields.audiences?.map(
      (audience) => audience.sys.id
    ) ?? []) {
      if ($matchingAudiences.value.includes(id)) {
        return experience;
      }
    }
  }
}
